/**
 * JWT Token 管理
 * 用于存储和管理 Slack OAuth 返回的 JWT Token
 */

const TOKEN_KEY = 'auth_token'
const TOKEN_EXPIRY_KEY = 'auth_token_expiry'

/**
 * 获取存储的 Token
 */
export function getAuthToken(): string | null {
  const token = localStorage.getItem(TOKEN_KEY)
  const expiry = localStorage.getItem(TOKEN_EXPIRY_KEY)

  // 检查是否过期
  if (expiry && Date.now() > parseInt(expiry, 10)) {
    clearAuthToken()
    return null
  }

  return token
}

/**
 * 设置 Token
 * @param token JWT Token
 * @param expiresIn 过期时间（秒），默认 7 天
 */
export function setAuthToken(token: string, expiresIn: number = 7 * 24 * 60 * 60): void {
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(TOKEN_EXPIRY_KEY, String(Date.now() + expiresIn * 1000))
}

/**
 * 清除 Token
 */
export function clearAuthToken(): void {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(TOKEN_EXPIRY_KEY)
}

/**
 * 检查 Token 是否即将过期（1 小时内）
 */
export function isTokenExpiringSoon(): boolean {
  const expiry = localStorage.getItem(TOKEN_EXPIRY_KEY)
  if (!expiry) {
    return true
  }

  const expiryTime = parseInt(expiry, 10)
  const oneHour = 60 * 60 * 1000
  return Date.now() > expiryTime - oneHour
}

/**
 * 解析 JWT Token 获取 payload（不验证签名）
 */
export function parseToken(
  token: string
): { id: string; email: string; role: string; exp: number } | null {
  try {
    const parts = token.split('.')
    if (parts.length !== 3) {
      return null
    }

    const payload = JSON.parse(atob(parts[1])) as { id: string; email: string; role: string; exp: number }
    return payload
  } catch {
    return null
  }
}
